export default __webpack_public_path__ + "static/media/gallery-img-1.92e9e456.jpg";